var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "taggregator" }, [
    _c("div", { staticClass: "info-main-row" }, [
      _c(
        "label",
        {
          staticClass: "taggregator-label",
          attrs: { for: "taggregator-input" },
        },
        [
          _vm._v("\n      " + _vm._s(_vm.label) + "\n      "),
          !!_vm.explainDisabled
            ? _c("b-tooltip", {
                attrs: {
                  target: `taggregator-input-field-${_vm.name}`,
                  placement: "top",
                  title: _vm.explainDisabled,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { attrs: { id: `taggregator-input-field-${_vm.name}` } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.search,
                  expression: "search",
                },
              ],
              staticClass: "form-control",
              attrs: {
                id: _vm.inputId,
                type: "text",
                name: "taggregator-input",
                disabled: _vm.isDisabled,
                placeholder: _vm.placeholder,
              },
              domProps: { value: _vm.search },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) return
                    _vm.search = $event.target.value
                  },
                  _vm.onChange,
                ],
                focus: _vm.filterSearchResults,
                blur: _vm.handleClickOutside,
                keydown: [
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "down", 40, $event.key, [
                        "Down",
                        "ArrowDown",
                      ])
                    )
                      return null
                    return _vm.onArrowDown.apply(null, arguments)
                  },
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "up", 38, $event.key, [
                        "Up",
                        "ArrowUp",
                      ])
                    )
                      return null
                    return _vm.onArrowUp.apply(null, arguments)
                  },
                  function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.onEnter.apply(null, arguments)
                  },
                ],
              },
            }),
          ]),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "ul",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isSearching,
            expression: "isSearching",
          },
        ],
        staticClass: "taggregator-search-results",
        attrs: { id: "taggregator-search-results" },
      },
      [
        _vm.isLoading
          ? _c("li", { staticClass: "loading" }, [
              _vm._v("\n      Loading results...\n    "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.createItemCallback
          ? _c(
              "li",
              {
                staticClass: "taggregator-search-result create-new-selection",
                on: {
                  mousedown: function ($event) {
                    return _vm.newSelection()
                  },
                },
              },
              [_c("b", [_vm._v("Add New +")])]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.quickAddCallback && !_vm.quickAddValid
          ? _c(
              "li",
              {
                staticClass:
                  "taggregator-search-result quick-add-new-selection unselectable",
              },
              [
                _c(
                  "div",
                  { staticClass: "quick-add-container" },
                  [
                    !_vm.quickAddValid
                      ? _c("b-tooltip", {
                          attrs: {
                            target: "quick-add-blurb",
                            placement: "left",
                            title: _vm.quickAddDescription,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { attrs: { id: "quick-add-blurb" } }, [
                      _c("b", [_vm._v("Quick Add " + _vm._s(_vm.search))]),
                    ]),
                  ],
                  1
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.quickAddCallback && _vm.quickAddValid
          ? _c(
              "li",
              {
                staticClass:
                  "taggregator-search-result quick-add-new-selection",
                on: {
                  mousedown: function ($event) {
                    return _vm.quickAddSelection()
                  },
                },
              },
              [_c("b", [_vm._v("Quick Add " + _vm._s(_vm.search))])]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.searchResults, function (result, i) {
          return !_vm.isLoading
            ? _c(
                "li",
                {
                  key: i,
                  staticClass: "taggregator-search-result",
                  class: { "is-active": i === _vm.arrowCounter },
                  on: {
                    mousedown: function ($event) {
                      return _vm.makeSelection(result)
                    },
                  },
                },
                [
                  _vm._t(
                    "result",
                    function () {
                      return [
                        _vm._v(
                          "\n        " +
                            _vm._s(result[_vm.labelKey]) +
                            "\n      "
                        ),
                      ]
                    },
                    { result: result }
                  ),
                ],
                2
              )
            : _vm._e()
        }),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "ul",
      {
        staticClass: "taggregator-selected-results",
        class: { hidden: _vm.selections > 0 },
        attrs: { id: "taggregator-selected-results" },
      },
      [
        _c(
          "li",
          _vm._l(_vm.selections, function (selection) {
            return selection && selection.id && selection[_vm.labelKey]
              ? _c(
                  "b-card",
                  {
                    key: selection.id,
                    staticClass: "selected-result-card text-center",
                    attrs: { value: selection, tag: "article" },
                  },
                  [
                    _vm._t(
                      "selection",
                      function () {
                        return [
                          selection[_vm.labelKey]
                            ? _c("p", { staticClass: "card-text" }, [
                                _vm._v(_vm._s(selection[_vm.labelKey])),
                              ])
                            : _vm._e(),
                        ]
                      },
                      { selection: selection }
                    ),
                    _vm._v(" "),
                    !_vm.disabled
                      ? _c("a", {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover.top",
                              value: "Remove",
                              expression: "'Remove'",
                              modifiers: { hover: true, top: true },
                            },
                          ],
                          staticClass: "remove-selection fi-x",
                          on: {
                            click: function ($event) {
                              return _vm.removeSelection(selection)
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e()
          }),
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }